<header class="topbar">
  <nav class="navbar top-navbar navbar-expand">
    <div class="">
      <a class="navbar-brand" routerLink="/sign-in">
        <div class="navbar-brand-wrap row">
          <div
            class="resp-img-container d-block d-sm-none my-auto topbar-icon mr-3"
          >
            <img
              class="logo-image"
              src="./assets/images/gallery/portal-logo.png"
              alt="homepage"
            />
          </div>
          <div class="resp-img-container my-auto d-none d-sm-block">
            <img
              class="logo-text-image"
              src="./assets/images/gallery/portal-ext-logo.png"
              alt="homepage"
              height="100"
            />
          </div>
        </div>
      </a>
    </div>
    <div class="navbar-collapse">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown row">
          <a
            routerLink="/sign-up"
            class="register dropdown-item flat-button pointer p-0 my-auto"
          >
            {{ 'HEADER.SIGN-UP' | transloco }}
          </a>
        </li>
        <li class="nav-item dropdown mx-2" style="font-size: 30px">
          <label class="separation"> | </label>
        </li>
        <li class="nav-item language flat-button row">
          <div class="my-auto">
            <a (click)="changeLanguage('en')" class="change-language pointer"
              >EN
            </a>
            <span class="cursor separation">|</span>
            <a (click)="changeLanguage('es')" class="change-language pointer">
              ES</a
            >
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>

@if (isLoading) {
  <div class="spinner-container">
    <mat-spinner diameter="82" />
  </div>
}

@if (!isLoading && isHashInvalid && !isPasswordReset) {
  <div class="invalid-token-container">
    <div class="container-card">
      <div class="card-content">
        <h3 class="box-title cursor general-title m-b-20">
          {{ 'RESTORE-PASSWORD-CONFIRM.INVALID-HASH' | transloco }}
        </h3>
        <p class="paragraph cursor">
          {{ 'RESTORE-PASSWORD-CONFIRM.INVALID-HASH-PARAGRAPH' | transloco }}
        </p>
      </div>
    </div>
  </div>
}

@if (!isLoading && !isHashInvalid && !isPasswordReset) {
  <div class="password-reset-container">
    <div class="container-card">
      <div class="card-content">
        <h3 class="box-title cursor general-title m-b-20">
          {{ 'RESTORE-PASSWORD-CONFIRM.CREATE-NEW-PASSWORD' | transloco }}
        </h3>
        <form
          ngNativeValidate
          [formGroup]="form"
          (ngSubmit)="resetPassword()"
          class="form-horizontal form-reset-password row mx-auto"
          id="loginform"
          action="index.html"
        >
          <div class="row m-0 w-100">
            <div class="form-group email">
              <span class="field-title cursor">{{
                'RESTORE-PASSWORD-CONFIRM.EMAIL' | transloco
              }}</span>
              <input
                formControlName="email"
                name="email"
                class="form-control"
                type="email"
                required
                placeholder="{{
                  'RESTORE-PASSWORD-CONFIRM.PLACEHOLDER-EMAIL' | transloco
                }}"
              />
              <span class="mandatory-field">{{
                'RESTORE-PASSWORD-CONFIRM.MANDATORY-FIELD' | transloco
              }}</span>
            </div>
          </div>
          <div class="row m-0 w-100">
            <div class="form-group password">
              <span class="field-title cursor">{{
                'RESTORE-PASSWORD-CONFIRM.PASSWORD' | transloco
              }}</span>
              <input
                formControlName="password"
                name="password"
                class="form-control"
                type="password"
                required
                placeholder="{{
                  'RESTORE-PASSWORD-CONFIRM.PLACEHOLDER-PASSWORD' | transloco
                }}"
              />
              <span class="mandatory-field">{{
                'RESTORE-PASSWORD-CONFIRM.MANDATORY-FIELD' | transloco
              }}</span>
            </div>
          </div>
          <div class="row m-0 w-100">
            <div class="form-group confirm-password">
              <span class="field-title cursor">{{
                'RESTORE-PASSWORD-CONFIRM.CONFIRM-PASSWORD' | transloco
              }}</span>
              <input
                formControlName="confirmPassword"
                name="confirmPassword"
                class="form-control"
                type="password"
                required
                placeholder="{{
                  'RESTORE-PASSWORD-CONFIRM.PLACEHOLDER-CONFIRM-PASSWORD'
                    | transloco
                }}"
              />
              <span class="mandatory-field">{{
                'RESTORE-PASSWORD-CONFIRM.MANDATORY-FIELD' | transloco
              }}</span>
            </div>
          </div>
          <div class="form-group button-container text-center p-b-10">
            <button
              [disabled]="form.invalid || isLoadingPasswordReset"
              class="submit-button btn btn-lg btn-block call-to-action btn-rounded btn-cards"
              type="submit"
            >
              <div class="submit-button-content">
                @if (isLoadingPasswordReset) {
                  <mat-spinner diameter="30"></mat-spinner>
                }
                @if (isLoadingPasswordReset) {
                  {{ 'RESTORE-PASSWORD-CONFIRM.LOADING' | transloco }}
                }
                @if (!isLoadingPasswordReset) {
                  {{
                    'RESTORE-PASSWORD-CONFIRM.CREATE-NEW-PASSWORD' | transloco
                  }}
                }
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}

@if (isPasswordReset) {
  <div class="password-restored-container">
    <img src="../../assets/images/images/restore-password-illustration-3.svg" />
    <div class="container-card">
      <div class="card-content">
        <h3 class="box-title cursor general-title m-b-20">
          {{ 'RESTORE-PASSWORD-CONFIRM.NEW-PASSWORD-CREATED' | transloco }}
        </h3>
        <p class="paragraph cursor">
          {{
            'RESTORE-PASSWORD-CONFIRM.NEW-PASSWORD-CREATED-PARAGRAPH'
              | transloco
          }}
        </p>
      </div>
    </div>
    <img src="../../assets/images/images/restore-password-illustration-4.svg" />
  </div>
}
